import { useAlert } from "@apex/component-library";
import { MENU_PERMISSIONS } from "apex-online-menu";
import { createContext, ReactNode, useContext } from "react";
import { useQuery } from "react-query";

import { Permissions as AllPermissions } from "../../permissions";
import {
  fetchPermissions,
  Permission,
  PermissionsResponse,
} from "./fetchPermissions";

interface PermissionsData {
  permissions: Permission[];
  isSuccess: boolean;
}

const initialContextState: PermissionsData = {
  permissions: [],
  isSuccess: false,
};

const PermissionsContext = createContext<PermissionsData>(initialContextState);

export function usePermissions() {
  return useContext(PermissionsContext);
}

interface PermissionsProviderProps {
  children: ReactNode;
}

export function PermissionsProvider({ children }: PermissionsProviderProps) {
  const { setAlert } = useAlert();
  const { data, isLoading, isSuccess } = useQuery<PermissionsResponse>({
    queryKey: "permissions",
    queryFn: () =>
      fetchPermissions([...Object.values(AllPermissions), ...MENU_PERMISSIONS]),
    refetchOnWindowFocus: false,
    retry: false,
    onError: () => {
      setAlert({
        variant: "error",
        description: "Error fetching permissions",
        title: "Error",
        isClosable: true,
      });
    },
  });
  return (
    <PermissionsContext.Provider
      value={{ permissions: data?.permissions || [], isSuccess }}
    >
      {isLoading ? null : children}
    </PermissionsContext.Provider>
  );
}
